import React, { Component } from "react";
import withRoot from "../withRoot";
import LoginPage from "../views/LoginPage/LoginPage";
import LandingPage from "../views/LandingPage/LandingPage";
import {
  userAuth,
  getAllData,
  setUnauthorizedHandler,
  setRefreshErrorHandler
} from "../api/api.js";
// import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import Snackbar from "@material-ui/core/Snackbar";

import ErrorBoundary from "./ErrorBoundary";

const KEY_CURRENT_USER = "currentUser";
const SESSION_EXPIRED_MESSAGE =
  "Your session has expired. Please log in again.";

class App extends Component {
  state = {
    user: { auth: false, username: "" },
    allData: {},
    loading: false,
    sessionWarning: null
  };

  componentDidMount() {
    setUnauthorizedHandler(this._handleUnauthorized);
    setRefreshErrorHandler(this._handleRefreshError);

    if (localStorage.hasOwnProperty(KEY_CURRENT_USER)) {
      try {
        const currentUser = localStorage.getItem(KEY_CURRENT_USER);
        const user = JSON.parse(currentUser);
        this._apiAllData(user);
      } catch (error) {
        localStorage.removeItem(KEY_CURRENT_USER);
      }
    }
  }

  componentWillUnmount() {
    setUnauthorizedHandler(null);
    setRefreshErrorHandler(null);
  }

  render() {
    const { user, allData, loading, sessionWarning } = this.state;
    const actions = {
      login: this._userLogin,
      logout: this._userLogout
    };
    if (!user.auth)
      return <LoginPage user={user} actions={actions} loading={loading} />;
    return (
      <ErrorBoundary>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <React.Fragment>
            <LandingPage user={user} actions={actions} allData={allData} />
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              open={Boolean(sessionWarning)}
              autoHideDuration={10000}
              onClose={this._handleSessionWarningClose}
              message={<span>{sessionWarning}</span>}
            />
          </React.Fragment>
        </MuiPickersUtilsProvider>
      </ErrorBoundary>
    );
  }

  _userLogin = async (username, password) => {
    this._sessionExpiredHandled = false;
    this.setState({
      loading: true,
      user: { auth: false },
      sessionWarning: null
    });
    const user = await userAuth(username, password);
    if (user.errors === null) {
      localStorage.setItem(KEY_CURRENT_USER, JSON.stringify(user));
      this._apiAllData(user);
    } else {
      this.setState({ user, loading: false });
    }
  };

  _userLogout = _ => {
    this._sessionExpiredHandled = true;
    localStorage.removeItem(KEY_CURRENT_USER);
    this.setState({
      user: { auth: false },
      allData: {},
      loading: false,
      sessionWarning: null
    });
  };

  _handleRefreshError = message => {
    this.setState({ sessionWarning: message });
  };

  _handleSessionWarningClose = (_, reason) => {
    if (reason === "clickaway") return;
    this.setState({ sessionWarning: null });
  };

  _handleUnauthorized = _ => {
    if (this._sessionExpiredHandled) return;

    this._sessionExpiredHandled = true;
    localStorage.removeItem(KEY_CURRENT_USER);
    this.setState({
      user: { auth: false, message: SESSION_EXPIRED_MESSAGE },
      allData: {},
      loading: false,
      sessionWarning: null
    });
  };

  _apiAllData = async user => {
    this.setState({ loading: true });
    const allData = await getAllData(user);
    this._checkAllData(user, allData);
  };

  _checkAllData = (user, allData) => {
    if (this._sessionExpiredHandled) return;

    if (allData.hasOwnProperty("info")) {
      if (
        Array.isArray(allData.info) &&
        allData.info.length === allData.apiInfo.length
      ) {
        this.setState({ user, allData, loading: false });
      }
    } else {
      this.setState({
        user: { errors: "api error, data not valid" },
        loading: false
      });
    }
  };
}

export default withRoot(App);
